import { Component, ChangeDetectionStrategy } from '@angular/core';
import { UtcDatePipe } from '../../shared/pipe/UtcDate.pipe';
import { LayoutService } from '../../core/service/layout.service';
import { ExtCircService } from '../service/extCirc.service';
import { RegistrantStatus } from '../../accounts/model/RegistrantStatus';
import { RevalidationStatus } from '../model/RevalidationStatus';


@Component({
    selector: 'app-extCirc-granted-revalidations',
    templateUrl: './extCirc-Granted-Revalidations.component.html',
    styleUrls: ['./extCirc-granted-revalidations.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExtCircGrantedRevalidationsComponent {

  loading = false;
  searchVisible = false;
  regNo = '';
  selectedDate: Date | null = null;
  heading = '';
  subHeading: any = null;
  displayRevalidationRecords = true;
  items: any[] = [];
  revalidations: any = null;
  revalidationDetails: any = null;
  registrantName: any = null;
  expectation: any = null;
  revalidationSelected: any = null;
  regNumber: any = null;
  RegistrationStatus = RegistrantStatus;
  RevalidationStatus = RevalidationStatus;
  error: any = null;

  searchCriteria = {
    regNumber: '',
    renewalDate: undefined,
    status: '' as RevalidationStatus | ''
  };
  tempItems: any[] = [];
  RevalStatus: any = null;
  isSearchClicked = false;

  constructor(
    public layout: LayoutService,
    private service: ExtCircService,
    private utcPipe: UtcDatePipe
  ) { }

  ngOnInit(): void {
    this.heading = 'Revalidation extensions';
    this.searchCriteria.status = '';
  }

  toggleSearch() {
    this.searchVisible = !this.searchVisible;
  }

  search() {
    if (this.searchCriteria.renewalDate == null) {
      return;
    }
    this.loading = true;
    this.isSearchClicked = true;
    this.searchCriteria.status = '';
    const payload = {
      renewalDate: this.searchCriteria.renewalDate
    }
    this.service.notSubmittedRevalidation(payload).subscribe((revalidationRecords: any) => {
      this.tempItems = revalidationRecords.records;
      this.tempItems.forEach(a => a.renewalDate = a.renewalDate);
      this.items = this.tempItems;
      this.loading = false;
    }, error => {
      this.loading = false;
    });

  }

  clearSearch() {
    this.searchCriteria.regNumber = '';
    this.searchCriteria.renewalDate = undefined;
    this.searchCriteria.status = '';
    this.items = [];
    this.tempItems = [];
    this.isSearchClicked = false;
  }

  dateChange(date: Date) {
    this.utcPipe.transform(date.toISOString());
  }

  filter(status: RevalidationStatus) {
    this.searchCriteria.status = status;
    this.items = this.tempItems?.filter((item) => {
      this.RevalStatus = RevalidationStatus[item.revalidationStage];
      return this.RevalStatus == status;
    });
  }

}
